/**
 * Copyright 2023 schukai GmbH
 * SPDX-License-Identifier: AGPL-3.0
 */

/**
 * Property-Keys
 * @author schukai GmbH
 */

export { internalSymbol, internalStateSymbol, instanceSymbol };

/**
 * @private
 * @type {symbol}
 * @memberOf Monster
 * @license AGPLv3
 * @since 1.24.0
 */
const internalSymbol = Symbol.for("@schukai/monster/internal");

/**
 * @private
 * @type {symbol}
 * @memberOf Monster
 * @license AGPLv3
 * @since 1.25.0
 */
const internalStateSymbol = Symbol.for("@schukai/monster/state");

/**
 * @private
 * @type {symbol}
 */
const instanceSymbol = Symbol.for("@schukai/monster/instance");
